import { Badge, Container, Row } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';

import Message from '../../components/layout/Message';
import Meta from '../../components/layout/Meta';
import ProductCard from '../../components/product/ProductCard';
import ProductCardSkeleton from '../../components/ui/ProductCardSkeleton';
import Paginate from '../../components/ui/Paginate';
import SortSelect from '../../components/ui/SortSelect';
import { useGetOutOfStockProductsQuery } from '../../slices/productApiSlice';

const OutOfStockProductsScreen = () => {
    const { userInfo } = useSelector((state) => state.auth);
    const { pageNumber, keyword } = useParams();

    const [searchParams] = useSearchParams();
    const sort = searchParams.get('sort') || '';

    const {
        data: productsData,
        isLoading,
        isFetching,
        error,
    } = useGetOutOfStockProductsQuery({
        keyword,
        pageNumber,
        priceAssigned: userInfo?.priceAssigned || null,
        sort,
    });

    return (
        <Container className="py-4">
            {!keyword ? <Meta title="Productos Agotados" /> : <Meta title={`Agotados: ${keyword}`} />}

            <div
                id="admin-out-of-stock-section"
                className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4 p-3 p-md-4 border rounded-4 bg-light"
            >
                <div className="d-flex align-items-center gap-3 flex-grow-1">
                    <div
                        className="d-flex align-items-center justify-content-center rounded-3"
                        style={{
                            width: '64px',
                            height: '64px',
                            backgroundColor: '#fff5f2',
                            color: '#b5430f',
                            border: '1px solid #f2d6cb',
                        }}
                    >
                        <FaExclamationTriangle size={24} />
                    </div>
                    <div>
                        <p className="text-muted mb-1 small">Panel de administracion</p>
                        <h1 className="mb-1 section-title">Productos agotados</h1>
                        <Badge bg="light" text="dark" className="border">
                            Busca, ordena y revisa productos sin stock
                        </Badge>
                    </div>
                </div>
                <div style={{ minWidth: '220px' }}>
                    <SortSelect currentSort={sort} />
                </div>
            </div>

            {isLoading || isFetching ? (
                <Row className="mx-0">
                    <div className="ProductGrid">
                        {[...Array(8)].map((_, idx) => (
                            <ProductCardSkeleton key={idx} />
                        ))}
                    </div>
                </Row>
            ) : error ? (
                <Message variant="danger">
                    {error?.data?.message || error?.error || 'Ocurrio un error al cargar los productos agotados.'}
                </Message>
            ) : (
                <>
                    {productsData?.products?.length === 0 ? (
                        <div className="text-center py-5 bg-light rounded-4 border">
                            <p className="text-muted mb-0">No hay productos agotados con los filtros actuales.</p>
                        </div>
                    ) : (
                        <>
                            <Row className="mx-0">
                                <div className="ProductGrid">
                                    {productsData?.products?.map((product) => (
                                        <ProductCard product={product} key={product._id} />
                                    ))}
                                </div>
                            </Row>
                            <div className="mt-4">
                                <Paginate
                                    pages={productsData?.pages}
                                    page={productsData?.page || 1}
                                    keyword={keyword || ''}
                                    sort={sort}
                                    isAdmin="outofstock"
                                    scrollTargetId="admin-out-of-stock-section"
                                />
                            </div>
                        </>
                    )}
                </>
            )}
        </Container>
    );
};

export default OutOfStockProductsScreen;

